var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEasy = function SvgEasy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6067",
    d: "M40.005 12.954A27.045 27.045 0 1 1 12.96 39.999a27.072 27.072 0 0 1 27.045-27.045m0-11.591A38.636 38.636 0 1 0 78.64 39.999 38.635 38.635 0 0 0 40.005 1.363",
    fill: "#2bd675"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6068",
    d: "M38.375 58.162 24.187 47.479a5.8 5.8 0 1 1 6.972-9.26l4.921 3.7 11.614-15.454a5.8 5.8 0 1 1 9.266 6.964Z",
    fill: "#495867"
  })));
};
export default SvgEasy;